/**
 * @typedef {Object} CartPreviewProduct
 * @property {string} [catalog]
 * @property {string} [prid]
 */

/**
 * @typedef {HTMLElement & { form?: HTMLFormElement & { dataset?: DOMStringMap } }} CartPreviewRelatedTarget
 */

/**
 * Handles the cart preview modal content and display behavior.
 */
export default class CartPreviewDialog {
  /**
   * @param {Object} params
   * @param {CartPreviewProduct[]} params.products
   * @param {CartPreviewRelatedTarget} [params.relatedTarget]
   */
  constructor({ products, relatedTarget }) {
    this.products = products;
    this.relatedTarget = relatedTarget;
    this.modalElement = document.querySelector('.js-cart-modal');

    if (!this.modalElement) {
      console.error('Cart modal element not found');
      return;
    }

    this.renderContent();
  }

  /**
   * Populates modal fields with the selected product details and recommendations.
   * @returns {void}
   */
  renderContent() {
    if (!this.products?.length) {
      console.error('Products array is empty');
      return;
    }

    const catalog = this.products[0].catalog;
    const prid = this.products[0].prid;

    if (!catalog || !prid) {
      console.error('Catalog or product ID not found');
      return;
    }

    // Update image
    const imageElement = this.modalElement.querySelector('.js-cartConfirmImage');
    if (imageElement && this.relatedTarget?.form?.dataset?.image) {
      imageElement.src = this.relatedTarget.form.dataset.image;
    } else {
      console.error('Image element or dataset image not found');
    }

    // Update title
    const titleElement = this.modalElement.querySelector('.js-cartConfirmTitle');
    if (titleElement && this.relatedTarget?.form?.dataset?.title) {
      titleElement.textContent = this.relatedTarget.form.dataset.title;
    } else {
      console.error('Title element or dataset title not found');
    }

    // Update recommendations
    const recoElement = this.modalElement.querySelector('.js-cartConfirmReco');
    if (recoElement) {
      let contentUrl = recoElement.getAttribute('content');
      if (contentUrl) {
        contentUrl = contentUrl.split('?')[0];
        recoElement.setAttribute('content', `${contentUrl}?prid=${catalog}-${prid}`);
      } else {
        console.error('Recommendation content attribute not found');
      }
    }

    this.showModal();
  }

  /**
   * Opens the cart preview modal when its dialog instance is available.
   * @returns {void}
   */
  showModal() {
    if (!this.modalElement) return;

    if (this.modalElement.instance?.dialog) {
      this.modalElement.instance.dialog.show();
    } else {
      console.error('Cart modal instance not found');
    }
  }
}
